module.exports = __webpack_public_path__ + "static/media/agnus-dei-p4.b6d05589.jpg";